/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiWorkshop
 */
export interface ApiWorkshop {
    /**
     * 
     * @type {number}
     * @memberof ApiWorkshop
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiWorkshop
     */
    name: string;
}

export function ApiWorkshopFromJSON(json: any): ApiWorkshop {
    return ApiWorkshopFromJSONTyped(json, false);
}

export function ApiWorkshopFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWorkshop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
    };
}

export function ApiWorkshopToJSON(value?: ApiWorkshop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

